import i18next from 'i18next';

i18next.addResources('es_CL', 'HistoryDetailsTable', {
  status: 'Estado',
  hour: 'Hora',
  user: 'Usuario',
  new: 'Nuevo',
  inProgress: 'Preparando',
  inDelivery: 'En tránsito',
  completeDetail: 'Detalle completo'
});

i18next.addResources('es_CR', 'HistoryDetailsTable', {
  status: 'Estado',
  hour: 'Hora',
  user: 'Usuario',
  new: 'Nuevo',
  inProgress: 'Preparando',
  inDelivery: 'En tránsito',
  completeDetail: 'Detalle completo'
});
